export function SiteFooter() {
  return (
    <footer className="site-footer">
      <p>Awesome NCO · A structured index for neural combinatorial optimization.</p>
      <nav aria-label="Footer navigation">
        <a href="https://github.com/CIAM-Group/awesome-nco" target="_blank" rel="noreferrer">GitHub</a>
        <a href="https://github.com/CIAM-Group/awesome-nco/blob/main/README.md" target="_blank" rel="noreferrer">README</a>
        <a href="https://github.com/CIAM-Group/awesome-nco/blob/main/CONTRIBUTING.md" target="_blank" rel="noreferrer">Contributing</a>
      </nav>
    </footer>
  )
}
